import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { ExpertMessageContextProvider } from "../hooks/expert-message/ExpertMessageContext";
import { ExpertTaskListContextProvider } from "../hooks/expert-task-list/ExpertTaskListContext";
import { ExpertMessageResponseContextProvider } from "../hooks/expert-message-response/ExpertMessageResponseContext";
import { ExpertMessageFlagContextProvider } from "../hooks/expert-message-flag/ExpertMessageFlagContext";
import { ExpertMessageClassficationContextProvider } from "../hooks/expert-message-classification/ExpertMessageClassificationContext";
import { ExpertMessageExtraInfoContextProvider } from "../hooks/expert-message-extra-info/ExpertMessageExtraInfoContext";
import { ExpertMessageReviewContextProvider } from "../hooks/expert-message-review/ExpertMessageReviewContext";
import { ExpertSuggestedAnswersContextProvider } from "../hooks/expert-suggested-answers/ExpertSuggestedAnswersContext";
import { useAuthenticationContext } from "../hooks/authentication/AuthenticationContext";
import { WebSocketsContextProvider } from "@limitless/common/hooks/web-sockets/WebSocketsContext";
import { useExpertWebSockets } from "../hooks/expert-web-sockets/ExpertWebSocketHook";
import { useExpertProfileContext } from "../hooks/expert-profile/ExpertProfileContext";
import { ExpertMessageQualityReviewContextProvider } from "../hooks/expert-message-quality-review/ExpertMessageQualityReviewContext";
import { ExpertAIReviewContextProvider } from "../hooks/expert-ai-review/ExpertAIReviewManagerContext";
export const ExpertLifecycleProvider = ({
  children
}) => {
  const {
    areWebSocketsEnabled
  } = useAuthenticationContext();
  const {
    profile
  } = useExpertProfileContext();
  const renderChildren = () => {
    if (!areWebSocketsEnabled) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    }
    return /*#__PURE__*/React.createElement(WebSocketsContextProvider, {
      shouldConnect: !profile.loading && profile.userName ? true : false,
      eventProcessorHook: useExpertWebSockets,
      profile: profile
    }, children);
  };

  // these are nested in a particular order due to the dependencies on each other
  // e.g. MessageResponse is needed by the Message
  return /*#__PURE__*/React.createElement(ExpertTaskListContextProvider, null, /*#__PURE__*/React.createElement(ExpertMessageResponseContextProvider, null, /*#__PURE__*/React.createElement(ExpertSuggestedAnswersContextProvider, null, /*#__PURE__*/React.createElement(ExpertMessageContextProvider, null, /*#__PURE__*/React.createElement(ExpertAIReviewContextProvider, null, /*#__PURE__*/React.createElement(ExpertMessageFlagContextProvider, null, /*#__PURE__*/React.createElement(ExpertMessageClassficationContextProvider, null, /*#__PURE__*/React.createElement(ExpertMessageReviewContextProvider, null, /*#__PURE__*/React.createElement(ExpertMessageExtraInfoContextProvider, null, /*#__PURE__*/React.createElement(ExpertMessageQualityReviewContextProvider, null, renderChildren()))))))))));
};
ExpertLifecycleProvider.propTypes = {
  children: PropTypes.node.isRequired
};